import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TrackingStatus from './TrackingStatus'

/**
 * Stav balíku
 */
export default class TParcelStatusDM extends Data {
	public static className = 'TParcelStatusDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Název
	 */
	Name?: string

	/**
	 * Datum události
	 */
	EventDate?: Date

	/**
	 * Pořadí
	 */
	SequenceNumber?: number

	/**
	 * Číslo balíku
	 */
	ParcelId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Stav
	 */
	@Type(() => TrackingStatus)
	StatusId?: TrackingStatus
}